import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { FrameIn } from 'projects/shared/src/interfaces/frame-in.interface';
import { FrameOutResponse } from 'projects/shared/src/interfaces/frame-out-response.interface';
import { Observable } from 'rxjs';
import { ShHeadersService } from '../headers/sh-headers.service';

@Injectable({
  providedIn: 'root',
})
export class ShApplicantService {
  client: any;

  constructor(
    private http: HttpClient,
    private _shSharedHeaders: ShHeadersService
  ) {}

  shGetClient(
    request: FrameIn,
    url: string,
    envHeaders: any
  ): Observable<FrameOutResponse> {
    return this.http.post<FrameOutResponse>(
      `${url}`,
      this._shSharedHeaders.buildBody(request),
      {
        headers: this._shSharedHeaders.buildHeaders(request, envHeaders),
      }
    );
  }
}
